<div
	@topBarAnimation
	class="relative z-50 flex h-[65px] items-center border-b border-solid border-outline-alt bg-background p-2"
>
	<!-- LOGO -->
	<button
		*hasRestrictedAccess="$droits()"
		class="flex cursor-pointer items-end px-2 transition-all duration-200"
		(click)="goToDashboard()"
	>
		<img
			src="/static-assets/imgs/agathe-you/logo-agathe-you.svg"
			alt="Agatheyou"
			class="h-10 w-auto"
		/>
	</button>

	<button
		*hasFullAccess="$droits()"
		class="flex flex-1 cursor-pointer items-center gap-4 p-2"
		(click)="openSearchDialog()"
	>
		<uikit-icon
			class="flex"
			size="md"
			name="search"
			fill="on-background-alt"
		/>
		<span class="text-base text-on-background-alt">Rechercher un patient</span>
	</button>
	<div
		*hasRestrictedAccess="$droits()"
		class="flex-1"
	></div>

	<div class="flex items-center">
		<button
			*hasFullAccess="$droits()"
			class="relative appearance-none p-2"
		>
			<!-- @TODO: décomenter quand on aura les notifications  -->
			<!--
			<uikit-icon
				class="rounded-full bg-background-alt p-1.5"
				name="bell"
				size="md"
				fill="on-background-alt"
			/>
			-->
		</button>

		<button
			*hasFullAccess="$droits()"
			class="relative appearance-none p-2"
			(click)="openNotificationsDialog()"
		>
			@if ($messageCount(); as count) {
				<span
					class="absolute right-0.5 top-0.5 h-4.5 w-4.5 content-center rounded-full border border-solid border-white bg-warning text-center font-display text-xs font-semibold text-on-warning shadow-lg shadow-[grey]"
					[class.text-2xs]="$smallMessageCountText()"
				>
					{{ count | messageCount }}
				</span>
			}
			<uikit-icon
				class="rounded-full bg-background-alt p-1.5"
				name="comments-alt"
				size="md"
				fill="on-background-alt"
			/>
		</button>

		<cba-menu-profile
			[fullClient]="$fullClient()"
			[loading]="$loading()"
			[droits]="$droits()"
		/>
	</div>
</div>
